import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, role, roles }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-sm text-gray-500" data-testid="auth-loading">
        Loading…
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  const allowed = roles ? roles : (role ? [role] : null);
  if (allowed && !allowed.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}
